import React from 'react';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';

const ConfirmDeleteModal = ({ open, onClose, onSubmit }) => (
  <Dialog open={open} onClose={onClose}>
    <DialogTitle>Excluir Regra</DialogTitle>
    <DialogContent>
      <DialogContentText>Tem certeza que deseja excluir esta regra?</DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button onClick={onClose} color="default">
        Não
      </Button>
      <Button onClick={onSubmit} color="primary" variant="contained">
        Sim
      </Button>
    </DialogActions>
  </Dialog>
);

export default ConfirmDeleteModal;
